import { render, staticRenderFns } from "./Boosts.vue?vue&type=template&id=96b2a9c4"
import script from "./Boosts.vue?vue&type=script&lang=js"
export * from "./Boosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports